/*!

=========================================================
* Paper Dashboard React - v1.3.0
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

* Licensed under MIT (https://github.com/creativetimofficial/paper-dashboard-react/blob/main/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import { useLocation } from "react-router-dom";
import { Navbar, NavbarBrand, Container } from "reactstrap";

// import routes from "routes.js";
import EventNotificationMenu from "./ComingEvents";
import Events from "./Events";
import styles from "./navbar.module.css";

function Header(props) {
  const sidebarToggle = React.useRef();
  const location = useLocation();
  const todayEvents = props.todayEvents;
  const weeklyEvents = props.weeklyEvents;
  const routes = props.routes;

  const getBrand = () => {
    let brandName = "Default Brand";
    routes?.map((prop, key) => {
      if (window.location.href.indexOf(prop.layout + prop.path) !== -1) {
        brandName = prop.name;
      }
      return null;
    });
    return brandName;
  };
  const openSidebar = () => {
    document.documentElement.classList.toggle("nav-open");
    sidebarToggle.current.classList.toggle("toggled");
  };

  React.useEffect(() => {
    if (
      window.innerWidth < 993 &&
      document.documentElement.className.indexOf("nav-open") !== -1
    ) {
      document.documentElement.classList.toggle("nav-open");
      sidebarToggle.current.classList.toggle("toggled");
    }
  }, [location]);
  return (
    // add or remove classes depending if we are on full-screen-maps page or not
    <Navbar
      color={"transparent"}
      expand="lg"
      className={
        props.location.pathname.indexOf("full-screen-maps") !== -1
          ? "navbar-absolute fixed-top"
          : "navbar-absolute fixed-top navbar-transparent py-1"
      }
    >
      <Container fluid>
        <div className={"navbar-wrapper " + styles.navbar_wrapper}>
          <div className={styles.brand}>
            <div className="d-flex">
              <div className="navbar-toggle">
                <button
                  type="button"
                  ref={sidebarToggle}
                  className="navbar-toggler"
                  onClick={() => openSidebar()}
                >
                  <span className="navbar-toggler-bar bar1" />
                  <span className="navbar-toggler-bar bar2" />
                  <span className="navbar-toggler-bar bar3" />
                </button>
              </div>
              <NavbarBrand className="py-0">{getBrand()}</NavbarBrand>
            </div>
            <div className={styles.event_small}>
              <Events todayEvents={todayEvents} weeklyEvents={weeklyEvents} />
            </div>
          </div>
        </div>

        <EventNotificationMenu
          todayEvents={todayEvents}
          weeklyEvents={weeklyEvents}
        />
      </Container>
    </Navbar>
  );
}

export default Header;
